import client from 'providers/postpaidClient'

export const getPostpaidUserInfo = () => client.get('/info')
